import { render, staticRenderFns } from "./EmployerContributionMatch.vue?vue&type=template&id=3797fd2c&"
import script from "./EmployerContributionMatch.vue?vue&type=script&lang=js&"
export * from "./EmployerContributionMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports